import Box from '@mui/material/Box';
import type { FunctionComponent } from 'react';

import type { GlobalSearchSkill } from '../../../data-contract/global-search';

type SkillGapPercentage = {
    readonly skill: GlobalSearchSkill;
};

export const SkillGapPercentage: FunctionComponent<SkillGapPercentage> = ({ skill }) => {
    const content = skill.jobsWithThisSkill === 0 ? 'NA' : `${(skill.skillGap.relative * 100).toFixed(0)}%`;

    return <Box sx={{ fontWeight: 'bold' }}>{content}</Box>;
};
